import { useState, useEffect } from 'react';

export const BREAKPOINTS = {
  xs: 480,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600,
} as const;

export const useResponsive = () => {
  const [screenWidth, setScreenWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1200
  );

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Kiểm tra ngay khi mount
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    isMobile: screenWidth <= BREAKPOINTS.md,
    isTablet: screenWidth > BREAKPOINTS.md && screenWidth <= BREAKPOINTS.lg,
    isDesktop: screenWidth > BREAKPOINTS.lg,
    screenWidth
  };
}; 